import { motion } from "framer-motion";

export default function Nav() {
  return (
    <motion.header
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      data-testid="nav-bar"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-black/40 border-b border-white/[0.06]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-serif text-base tracking-tight text-white"
        >
          MB.<span className="text-[#C09D64]">_</span>
        </a>
        <nav className="hidden md:flex items-center gap-10 text-xs uppercase tracking-[0.18em] text-zinc-400">
          <a
            href="#experience"
            data-testid="nav-experience"
            className="hover:text-white transition-colors duration-300"
          >
            Experience
          </a>
          <a
            href="#projects"
            data-testid="nav-projects"
            className="hover:text-white transition-colors duration-300"
          >
            Work
          </a>
          <a
            href="#contact"
            data-testid="nav-contact"
            className="hover:text-white transition-colors duration-300"
          >
            Contact
          </a>
        </nav>
        <a
          href="#contact"
          data-testid="nav-cta-contact"
          className="hidden md:inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] border border-white/15 rounded-full px-4 py-2 hover:bg-white hover:text-black transition-colors duration-300"
        >
          Get in touch
        </a>
      </div>
    </motion.header>
  );
}
